import { EventNames, globalEventBus } from '@littlebird/event-bus';
import { useEffect } from 'react';

import { invalidateTeamChat } from '@/features/team-chats/team-chats.query';

import { invalidateProjectFiles } from './project-files.queries';
import { invalidateProjectMembers } from './project-members.query';
import {
  invalidateProjectChats,
  invalidateProjectMeetings,
} from './project-shared-content.query';

/** Keep open shared-project data fresh without debouncing invalidations. */
export const useProjectsChangedEvents = () => {
  useEffect(() => {
    const subscription = globalEventBus.on(
      EventNames.PROJECTS_CHANGED,
      ({ data }) => {
        invalidateProjectChats(data.project_id);
        invalidateProjectMeetings(data.project_id);
        invalidateProjectMembers(data.project_id);
        invalidateProjectFiles(data.project_id);
      }
    );

    const teamChats = globalEventBus.on(
      EventNames.TEAM_CHATS_CHANGED,
      ({ data }) => invalidateTeamChat(data.project_id, data.chat_id)
    );

    return () => {
      subscription.unsubscribe();
      teamChats.unsubscribe();
    };
  }, []);
};
